"use strict";
var has = require("../internals/set-helpers").has;
module.exports = function(it) {
  has(it);
  return it;
};
